import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { PageState } from 'app/store/models/page.model';

import { setBannerComponent } from 'app/store/actions/page.action';

@Component({
  selector: 'app-enterpise',
  templateUrl: './enterpise.component.html',
  styleUrls: ['./enterpise.component.scss'],
})
export class EnterpiseComponent implements OnInit {
  constructor(private store: Store<PageState>) {
    this.store.dispatch(setBannerComponent({ banner: 'Enterprise' }));
  }

  ngOnInit() {}
}
